import { render, staticRenderFns } from "./DetailAboutElections.vue?vue&type=template&id=4066929c&scoped=true"
import script from "./DetailAboutElections.vue?vue&type=script&lang=js"
export * from "./DetailAboutElections.vue?vue&type=script&lang=js"
import style0 from "./DetailAboutElections.vue?vue&type=style&index=0&id=4066929c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4066929c",
  null
  
)

export default component.exports